import { Flex, IconButton, Tooltip } from '@chakra-ui/react';
import { MdEdit } from 'react-icons/md';

import { TableColumn } from '@app/components/common/table';

export const useColumns = ({
  onEdit,
}: {
  onEdit: (item: EntityBase) => void;
}): TableColumn<EntityBase>[] => [
  {
    name: 'id',
    label: '#',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'name',
    label: 'Название',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'actions',
    label: 'Действия',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (_id, { rowData }) => (
        <Flex>
          <Tooltip label="Изменить">
            <IconButton
              aria-label="edit"
              size="sm"
              onClick={() => onEdit(rowData)}
            >
              <MdEdit />
            </IconButton>
          </Tooltip>
        </Flex>
      ),
    },
  },
];
